import { useCallback } from 'react';

import { ItemUnit } from '@dreryk/egabinet-invoice-frontend-api';

import { useTranslate } from '@dreryk/react-common';
import { InteractiveTable, InteractiveTableCellProps } from '@dreryk/react-components';

import { invoiceCreateModalTranslationKeys } from '../../../translations';

type InvoiceItemsTableUnitSelectCellProps = InteractiveTableCellProps<ItemUnit>;

const ITEM_UNITS: ItemUnit[] = ['ITEM', 'SERVICE'];

const useTriggerLabelExtractor = (): ((itemUnit: ItemUnit | undefined) => string) => {
   const translate = useTranslate();

   return useCallback(
      (item) => {
         if (!item) {
            return '';
         }

         return translate(invoiceCreateModalTranslationKeys.table.unitMap[item]);
      },
      [translate]
   );
};

export const InvoiceItemsTableUnitSelectCell = (props: InvoiceItemsTableUnitSelectCellProps): JSX.Element => {
   return (
      <InteractiveTable.SelectCell<ItemUnit>
         testId={props.testId}
         name={props.name}
         index={props.index}
         validationRules={props.validationRules}
         defaultValue={props.defaultValue}
         triggerLabelExtractor={useTriggerLabelExtractor()}
      >
         <InteractiveTable.SelectCell.List<ItemUnit> items={ITEM_UNITS}>
            {(itemUnit: ItemUnit) => (
               <InteractiveTable.SelectCell.Item
                  testId={itemUnit}
                  item={itemUnit}
                  label={invoiceCreateModalTranslationKeys.table.unitMap[itemUnit]}
               />
            )}
         </InteractiveTable.SelectCell.List>
      </InteractiveTable.SelectCell>
   );
};
